import React from "react";

import { Page } from "../Page";
import { OptionsMenuItem } from "../OptionsMenuItem";
import { IconCode, IconLockPassword, IconRobotFace } from "../icons";

export namespace AccountSecurityPage {
  export interface Props {
    homePath: string;
    changePasswordPath: string;
    apiTokensPath: string;
    mcpConnectionsPath: string;
  }
}

export function AccountSecurityPage(props: AccountSecurityPage.Props) {
  const navigation = React.useMemo(
    () => [{ to: props.homePath, label: "Главная" }],
    [props.homePath],
  );

  return (
    <Page title="Пароль и безопасность" size="small" testId="account-security-page" navigation={navigation}>
      <div className="px-4 sm:px-10 py-8">
        <div className="mb-2 text-content-accent text-3xl font-extrabold">Пароль и безопасность</div>
        <p className="mb-8">Управляй тем, как осуществляется вход и предоставляется доступ к Operately.</p>

        <OptionsMenuItem
          linkTo={props.changePasswordPath}
          icon={IconLockPassword}
          title="Сменить пароль"
          description="Обнови пароль для входа"
        />
        <OptionsMenuItem
          linkTo={props.apiTokensPath}
          icon={IconCode}
          title="API-токен"
          description="Создавай токены для программного доступа и управляй ими"
        />
        <OptionsMenuItem
          linkTo={props.mcpConnectionsPath}
          icon={IconRobotFace}
          title="MCP-подключения"
          description="Проверить и отозвать подключения AI-клиентов"
        />
      </div>
    </Page>
  );
}
